export const COMPLIANCE_DOCUMENT_REWRITE_DOCUMENT_TYPES = [
  'RISK_ASSESSMENT',
  'INSTRUCTION_HANDBOOK',
] as const

export type ComplianceDocumentRewriteDocumentType =
  (typeof COMPLIANCE_DOCUMENT_REWRITE_DOCUMENT_TYPES)[number]

export const COMPLIANCE_DOCUMENT_REWRITE_OUTCOMES = [
  'accepted',
  'rejected',
] as const

export type ComplianceDocumentRewriteOutcome =
  (typeof COMPLIANCE_DOCUMENT_REWRITE_OUTCOMES)[number]

export const REWRITE_INSUFFICIENT_SOURCES_ERROR_CODE =
  'REWRITE_INSUFFICIENT_SOURCES' as const

export const REWRITE_INVALID_OUTPUT_ERROR_CODE =
  'REWRITE_INVALID_OUTPUT' as const

export const REWRITE_GATE_UNAVAILABLE_ERROR_CODE =
  'REWRITE_GATE_UNAVAILABLE' as const

export const REWRITE_INSTRUCTION_REFUSED_ERROR_CODE =
  'REWRITE_INSTRUCTION_REFUSED' as const
